import angular from 'angular';

class AppSessionCapabilities {
  constructor(appSession) {
    'ngInject';

    this.appSession = appSession;
  }
  getSession() {
    return this.appSession.getSession();
  }
  getPermissions() {
    return this.getSession().application.permissions;
  }
  hasPermissions(names, any = false) {
    const list = angular.isArray(names) ? names : [names];
    const permissions = this.getPermissions();
    return any ?
      list.some((name) => permissions[name] === true) :
      !list.some((name) => permissions[name] !== true);
  }
  hasRoutePermissions(names) {
    return !names.some((name) => !this.hasPermissions(name, angular.isArray(name)));
  }
  isSelf(userId) {
    return this.getSession().user.id === userId;
  }
  isSuperAdmin() {
    return this.hasPermissions('super_admin');
  }
  isAdmin(allowHigherRoles = true) {
    return allowHigherRoles ?
      this.hasPermissions(['admin', 'super_admin'], true) :
      this.hasPermissions(['admin']);
  }
  isBrandAdmin(allowHigherRoles = true) {
    return allowHigherRoles ?
      this.hasPermissions(['brand_admin', 'admin', 'super_admin'], true) :
      this.hasPermissions(['brand_admin']);
  }
  isSelfAdmin() {
    return this.hasPermissions('selfadmin');
  }
  isViewer(allowHigherRoles = true) {
    return allowHigherRoles ?
      this.hasPermissions(['read_only', 'brand_admin', 'admin', 'super_admin'], true) :
      this.hasPermissions('read_only');
  }
  canUpdateUserInformation(user) {
    return !this.isSelf(user.id) && this.isSuperAdmin();
  }
  canUpdateUserRole(user) {
    let can = false;
    if (!this.isSelf(user.id)) {
      const isBasic = !this._hasAtLeastOnePermission(user);
      const lowerRole = isBasic || (user.permissions.brand_admin || user.permissions.read_only);
      can = this.isSuperAdmin() || (
        (this.isAdmin(false)) && lowerRole
      );
    }

    return can;
  }
  canAssignBrandToNewUser() {
    return this.isBrandAdmin();
  }
  canChangeBrandAdminSettings() {
    return this.isAdmin();
  }
  canUpdateBrandPermissions() {
    return this.isBrandAdmin();
  }
  canAssignUserToNewBrand(user) {
    return this.isBrandAdmin() || (this.isSelf(user.id) && this.isSelfAdmin());
  }
  canUpdateUserPermissions(user) {
    return this.isBrandAdmin() || (this.isSelf(user.id) && this.isSelfAdmin());
  }
  canCreateUser() {
    return this.isBrandAdmin();
  }
  canDeleteUser() {
    return this.isSuperAdmin() || this.isBrandAdmin(false);
  }
  canSeeUserActivities() {
    return this.isBrandAdmin();
  }
  _hasAtLeastOnePermission(user) {
    return Object.keys(user.permissions).find((name) => user.permissions[name] === true);
  }
}

export default AppSessionCapabilities;
